import { render, staticRenderFns } from "./SmsNotifications.vue?vue&type=template&id=91596df0&"
import script from "./SmsNotifications.vue?vue&type=script&lang=js&"
export * from "./SmsNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports